<template>
    <section>
        <div class="left">
            <h2 v-translate>Přiřazená zařízení</h2>
        </div>

        <div class="right checkbox_group">
            <p class="check_all">
                <input
                    @click="checkAll"
                    id="checkall"
                    name="checkall"
                    type="checkbox"
                    :checked="entity.device_ids.length === 0"
                    :disabled="!$_updateActionAllowed"
                />
                <label for="checkall" v-translate>Všechna zařízení</label>
            </p>
            <ul>
                <li v-for="(device, key) in devices">
                    <input
                        :id="'device_' + key"
                        :name="'device_' + key"
                        type="checkbox"
                        :value="~~(key)"
                        v-model="entity.device_ids"
                        :disabled="!$_updateActionAllowed"
                    />
                    <label :for="'device_' + key">{{ device }}</label>
                </li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
    name: "deviceList",
    props: ["devices", "entity"],
    methods: {
        checkAll() {
            if (this.entity.device_ids.length > 0) {
                this.entity.device_ids = [];
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/views/channelGroups/detail/deviceList.vue